"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const style_1 = require("./style");
const ErrorApiKeyRenderer = ({ style, platform }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const isMobile = platform === 'ios' || platform === 'android';
    const styleView = (0, react_1.useMemo)(() => ({
        width: style === null || style === void 0 ? void 0 : style.width,
        height: style === null || style === void 0 ? void 0 : style.height,
        maxHeight: style === null || style === void 0 ? void 0 : style.maxHeight,
        minHeight: style === null || style === void 0 ? void 0 : style.minHeight,
    }), [style]);
    return (react_1.default.createElement(Render.View, { style: styleView },
        react_1.default.createElement(Render.ImageBackground, { style: style_1.imageBackground, source: { uri: 'https://firebasestorage.googleapis.com/v0/b/odcreator-3acbb.appspot.com/o/resources%2Fmedia%2Fimages%2Fmap-background-not-apiKey.png?alt=media&token=bacc1dd5-81f4-4358-8327-c5e4ac89e334' }, resizeMode: "cover" },
            react_1.default.createElement(Render.View, { style: style_1.svgContainer },
                react_1.default.createElement(Render.SvgImage, { src: "https://firebasestorage.googleapis.com/v0/b/odcreator-3acbb.appspot.com/o/resources%2Fmedia%2Fsvg%2FiconBlocked.svg?alt=media&token=2e13db62-2861-4e80-a3cc-325f07e79b7d" })),
            react_1.default.createElement(Render.Text, { style: style_1.bodyText }, "To use this control you need to set a Google key. After add it, reload your app"),
            react_1.default.createElement(Render.TouchableOpacity, { style: isMobile ? style_1.buttonMobile : style_1.button, onPress: () => window.open('https://comunidad.apphive.io/t/paso-a-paso-de-como-obtener-tu-api-key-de-google/2500', '_blank') },
                react_1.default.createElement(Render.Text, { style: isMobile ? style_1.buttonMobileText : style_1.buttonText, onPress: () => react_native_1.Linking.openURL('https://comunidad.apphive.io/t/paso-a-paso-de-como-obtener-tu-api-key-de-google/2500') }, "Add my API Key")))));
};
exports.default = ErrorApiKeyRenderer;
